class loadingButton extends HTMLElement {
  constructor() {
    super();
    this.url = '';
    this.total = 0;
    this.loaded = 0;
    this.progressBar = this.querySelector('.progress-bar');
    if (this.progressBar) {
      this.progressBar.value = this.loaded;
    }
    this.resultCount = document.querySelectorAll('.js-result-count');
    this.singleResultCount = document.querySelectorAll('.js-result-count-single');
    this.automaticLoading = this.getAttribute('automatic-loading');
    this.loadButtonContainer = this.closest('.pagination-wrapper');
    this.loadButton = this.querySelector('button');
    this.productContainer = document.querySelector('#product-grid');
    this.articleContainer = document.querySelector('#article-grid');
    this.vanillaPagination = document.querySelector('#pagination');
    this.loadButton.addEventListener(
      'click',
      this.loadMore.bind(this)
    );

    // loading observer
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.25
    };
    this.observer = new IntersectionObserver(this.handleIntersection, options);
  }

  connectedCallback() {
    if (this.automaticLoading === 'true') {
      this.observer.observe(this.loadButton);
    }
    this.loaded = parseInt(this.loadButton.getAttribute('data-loaded-products-total'));
    this.total = parseInt(this.loadButton.getAttribute('data-total-results-count'));
    this.updateProgress();
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        entry.target.closest('loading-button').loadMore();
      }
    });
  }

  loadMore() {
    this.url = document.querySelector('.pagination-wrapper a.pagination__item--next').href;
    this.loadButton.classList.add('loading');
    this.loadButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    this.fetchItems(this.url);
  }

  fetchItems(url) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        url.includes("blog") ? this.renderArticleGrid(html) : this.renderProductGrid(html);
        this.renderNewNavigation(html);
        this.loadingButtonChecker();
        this.updateProgress();
      });
  }

  renderProductGrid(html) {
    let newPage = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid').innerHTML
    this.productContainer.innerHTML = this.productContainer.innerHTML + newPage;
    this.loaded = this.productContainer.querySelectorAll('.product').length;
  }

  renderArticleGrid(html) {
    let newPage = new DOMParser().parseFromString(html, 'text/html').getElementById('article-grid').innerHTML;
    this.articleContainer.innerHTML = this.articleContainer.innerHTML + newPage;
    this.loaded = this.articleContainer.querySelectorAll('.blog-articles__article').length;
  }

  renderNewNavigation(html) {
    this.vanillaPagination.innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('pagination').innerHTML;
  }

  loadingButtonChecker() {
    this.loadButton.classList.remove('loading');
    this.loadButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
    if (document.querySelectorAll('.pagination-wrapper a.pagination__item--next').length === 0) {
      this.loadButtonContainer.classList.add('hidden');
    }
  }

  updateProgress() {
    let progress = (this.loaded / this.total) * 100;
    if (this.progressBar) {
      this.progressBar.setAttribute("style", "--progress:" + `${progress}` + "%");
    }

    this.resultCount.forEach((counter) => {
      const loaded = this.total < this.loaded ? this.total : this.loaded;
      counter.textContent = `Showing ${loaded} of ${this.total} items... ${test}`;
    });

    this.singleResultCount.forEach((counter) => {
      counter.textContent = `${this.loaded} items`;
    });
  }
}

customElements.define('loading-button', loadingButton);